import { Avatar, Box, Icon, Paper, Stack, Typography } from "@mui/material"
import { slickSettings } from "../../../../utils/helper"
import Icons from "../../../../assets/js/Icons"
import Slider from "react-slick"
import { useRef } from "react"

const asideReviews = [
  {
    name: "Lucas Gray",
    role: "Verified Member",
    avatarColor: "#4f46e5",
    rating: 5,
    content: "InnerPal has been a guiding light in my recovery journey. The specialists genuinely care and the tools are easy to use every single day.",
  },
  {
    name: "Samantha Reed",
    role: "Verified Member",
    avatarColor: "#059669",
    rating: 5,
    content: "Having access to counselors, workshops, and supportive forums all in one platform gave me back my peace of mind and daily focus.",
  },
  {
    name: "Ananya Patel",
    role: "Verified Member",
    avatarColor: "#d97706",
    rating: 5,
    content: "The customized plan transformed how I manage daily stress and work pressure. Truly a wonderful platform for holistic wellness.",
  },
]

function Testimonials() {
  const setting = {
    ...slickSettings,
    speed: 800,
    autoplay: true,
    slidesToShow: 1,
    autoplaySpeed: 5000,
  }

  const slickRef = useRef(null)

  return (
    <Slider {...setting} ref={slickRef}>
      {asideReviews.map((item, i) => (
        <Box key={i} px={2}>
          <Paper sx={{ p: "25px", borderRadius: 2, boxShadow: "0px 0px 20px 0px #00000018" }}>
            <Box sx={{ borderBottom: "1px solid #dfdfdf", minHeight: "130px" }}>
              <Stack
                spacing={0.5}
                direction="row"
              >
                {new Array(5).fill().map((_, starIndex) => (
                  <Icon
                    key={starIndex}
                    sx={{
                      fontSize: "18px",
                      color: starIndex < item.rating ? "#e5b216" : "#d6d6d6"
                    }}
                  >
                    <Icons.Star />
                  </Icon>
                ))}
              </Stack>
              <Typography
                sx={{
                  py: "15px",
                  color: "#484f56",
                  fontWeight: "500",
                  lineHeight: "24px",
                  fontSize: "14px"
                }}
              >
                "{item.content}"
              </Typography>
            </Box>
            <Box
              sx={{
                gap: 2,
                mt: "20px",
                display: "flex",
                alignItems: "center"
              }}
            >
              <Avatar
                sx={{
                  width: { xs: "45px", lg: "50px" },
                  height: { xs: "45px", lg: "50px" },
                  bgcolor: item.avatarColor,
                  fontWeight: 700,
                  fontSize: "16px"
                }}
              >
                {item.name.split(" ").map(n => n[0]).join("")}
              </Avatar>
              <Box>
                <Typography
                  sx={{
                    color: "other.color1",
                    fontWeight: "700",
                    lineHeight: "1.2",
                    fontSize: { xs: "16px", lg: "18px" },
                  }}
                >
                  {item.name}
                </Typography>
                <Typography
                  sx={{
                    mt: 0.5,
                    color: "#6c757d",
                    fontWeight: "500",
                    fontSize: "13px"
                  }}
                >
                  {item.role}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Box>
      ))}
    </Slider>
  )
}

export default Testimonials